import { Box, Spinner } from '@arpeggi/ui'

export const CenteredSpinner = () => {
  return (
    <Box column alignCenter justifyCenter>
      <Spinner size="md" />
    </Box>
  )
}
